<!--
일괄기능 — 대금상환 「송금취소 일괄처리」 (TASK-161 §0-5 · 미결 4 · 결정 27 — 구매요청과 같은 공용 배치 컴포넌트 job · 라벨 결정 29·30)
------------------------------------
 - 버튼 (blade) → jobInit() → 모달. 대상 = 선택 항목 (CodPaymentIndexTrait::codBatchJson 의 items)
 - 송금취소 가능 = 송금완료 건만. 송금완료가 아닌 건이 섞이면 안내하고 차단 (송금취소 확인 비활성 — 선택 해제 후 재시도)
 - 착지 = 정산확정 (사이클 14 결정 49 b — 정산금액 유지) · 상태값 = batch.states
 - 사유 textarea (선택 — 미결 4 임시 채택, 전 건 동일 사유) → POST /admin/cod-payments/unsettlements (ids[] + reason)
 - 서버 Logic 거부 문구 = 그대로 alert (전체 롤백) · 성공 = 서버 msg alert 후 새로고침
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-unsettle-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">송금취소 일괄처리</h3>

            <div class="uk-margin-small">
                선택 {{ targets.length }}건 (송금완료 {{ settledCount }}건)
                <div class="uk-text-danger cdp-unsettle-blocked" v-if="otherCount > 0">
                    송금완료가 아닌 건이 {{ otherCount }}건 섞여 있어 송금취소할 수 없습니다.
                    송금완료 건만 선택한 뒤 다시 진행해 주세요.
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">송금취소 사유 (선택)</label>
                <div class="uk-form-controls">
                    <textarea class="uk-textarea cdp-unsettle-reason" rows="3" v-model="inputReason" placeholder="송금취소 사유 (선택 — 선택 건 전체에 동일 적용)"></textarea>
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-danger cdp-unsettle-submit" type="button"
                        :disabled="busy || otherCount > 0 || settledCount === 0" @click="submit">송금취소 확인</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from '../../cod-payment/popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            /**
             * 일괄기능 공유data (CodPaymentIndexTrait::codBatchJson)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 항목)
                targets: [],

                inputReason: '',
            };
        },
        computed: {
            // App\Code\CodPayment\State::SETTLED (batch.states.settled — 결정 49 d 재번호 추종)
            settledCount() {
                let settled = parseInt(this.batch.states.settled, 10);
                return this.targets.filter((item) => parseInt(item.state, 10) === settled).length;
            },

            // 송금취소 대상이 아닌 (송금완료가 아닌) 선택 건수
            otherCount() {
                return this.targets.length - this.settledCount;
            },
        },
        methods: {
            // 작업초기화 (버튼 클릭 → 모달)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 대금상환이 없습니다.');
                    return;
                }
                if (this.settledCount === 0) {
                    alert('송금취소할 수 있는 송금완료 건이 없습니다.');
                    return;
                }

                this.inputReason = '';
                this.show();
            },

            submit() {
                if (this.busy || this.otherCount > 0 || this.settledCount === 0) {
                    return;
                }
                this.request('post', '/admin/cod-payments/unsettlements', {
                    ids: _.map(this.targets, 'id'),
                    reason: this.inputReason.trim(),
                }).then(this.done);
            },
        },
    }
</script>
